<main class="p-4 container-lg">
  @if (loading){
  <div class="row">
    <div class="col-12 text-center">
      <i class="fa-solid fa-circle-notch fa-spin fa-2xl p-5"></i>
    </div>
  </div>
  }

  @if(!loading && !hasError){
  <h1>Purchase Confirmation</h1>
  <p class="fs-3">
    Thank you for your purchase.
  </p>
  <p>
    Your access level is <span class="fs-4 fw-bold">{{subscription.subscriptionLevel == 1 ? 'Lite' : 'Advanced'}} {{hasAIEngineerSubscription && !isAIEngineerSubscriptionExpired  ? 'with AI Engineer' : ''}}</span>
  </p>

  <a routerLink="" class="btn btn-outline-primary mt-3 px-5">Get Started</a>
  }

  @if (!loading && hasError){
  <h2>Error Getting Purchase Information</h2>
  <p>
    We are sorry for the inconvenience but an error occurred confirming your purchase. If your transaction completed successfully, please contact support. Do not attempt
    to purchase again. This will result in having to issue a refund.
    Try logging out and logging back in.
    If your account does not reflect the correct access level, please contact support. <a href="mailto:support@gtprotune.com">support&#64;gtprotune.com</a>
  </p>
  }
 </main>
